import { Common } from '../utility/common';
import { AppConfig } from 'app/app.config';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventList } from 'app/shared/utility/EventAggregator';
import { BaseComponent } from 'app/shared/baseClasses/BaseComponent';
import { CustomAlertComponent } from './custom-alert/custom-alert.component';
import { EditUserComponent } from './edit-user/editUser.component';
import { CaseCommentThreadComponent } from 'app/case-comment-thread/case-comment-thread.component';
import { CaseInfoComponent } from './case-info/case-info.component';
import { UserAccess } from '../models/userModel';
import { CaseListComponent } from './case-list/case-list.component';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent extends BaseComponent implements OnInit {
  constructor (appConfig: AppConfig, private modal: MatDialog) {
    super(appConfig);
  }

  ngOnInit() {
    this.subscribeEvent(EventList.popupTriggered, event => {
      if (event.type)
      {
        switch (event.type) {
          case "alertMessage":
            let alertInput = event.value as AlertPopupInput;
            this.modal.open(CustomAlertComponent, Object.assign({data: { title: alertInput.title, msg: alertInput.msg }}, Common.ModalConfig));
            break;
          case "userEdit":
            let editUserInput = event.value as EditUserPopupInput;
            this.modal.open(EditUserComponent, Object.assign({data: editUserInput}, Common.ModalConfig ));
            break;
          case "caseCommentThread":
            let caseCommentThreadInput = event.value as CaseCommentThreadPopupInput;
            this.modal.open(CaseCommentThreadComponent, Object.assign({data: { ocme: caseCommentThreadInput.ocme, caseId: caseCommentThreadInput.caseId, id: caseCommentThreadInput.id }}, Common.ModalConfig));
            break;
          case "caseDetails":
            let caseInfoInput = event.value as CaseInfoPopupInput;
            this.modal.open(CaseInfoComponent, Object.assign({data: { caseDetails: caseInfoInput.caseDetails, printMode: caseInfoInput.printMode }}, Common.ModalConfig));
            break;
          case "caseList":
            let caseListInput = event.value as CaseListPopupInput;
            this.modal.open(CaseListComponent, Object.assign({data: caseListInput}, Common.ModalConfig));
            break;
        }
      }
    });
  }
}

export interface PopupInput {
  type: string,
  value: any
}

interface AlertPopupInput extends PopupInput {
  title: string,
  msg: string
}

interface EditUserPopupInput extends PopupInput {
  user: UserAccess
}

interface CaseCommentThreadPopupInput extends PopupInput {
  id: string,
  caseId: string,
  ocme: string
}

interface CaseInfoPopupInput extends PopupInput {
  caseDetails: string,
  printMode: string,
}

interface CaseListPopupInput extends PopupInput {
  caseCategory: any,
  caseList: any,
  printMode: any,
}